	<template>
	<div class="tree-component">
		
		<div class="row" v-for="(cB, index) in orderedTree" :key='index' :class="{ 'root-row': index === 0 }">
			<!-- <button v-if="editMode ==0" v-on:click="test({ClientBranch:cB,mode:'Test'})">C</button> -->

			<!-- DIGEST -->
			<div class="col-1 box" v-if="editMode == 0"
				v-bind:class="{
					hover: !activeChild && !cB.Branch.Child.isCollection,
					center: !cB.tools.digest[0][2],
					'box-top-border':cB.path=='001'
				}"
				v-on:click="activeChild && cB.Branch.Child.isCollection ? null : !activeChild?$emit('callTool', {ClientBranch:cB,tool:'digest',state:true}):null"
				v-bind:tabindex="0"
				v-on:keyup.esc="$emit('callTool', {ClientBranch:cB,tool:'digest',state:false})"
				>

				<!-- Branch Digest -->
				<div class="digest"
					v-bind:class="{
						edit: !cB.tools.digest[0] && enableEdit && !cB.Branch.Child.isCollection && !activeChild,
					}"
					v-text="cB.Branch.digest"
				/>
				<!-- Digest Buttons -->
				<BranchButtons
					class="popup-div"
					v-if="cB.tools.digest[0][2]"
					v-on:branchToolCode="updateDigest(cB,$event)"
					v-bind:btnConfig="cB.tools.digest"
					/>
			</div>

			<!-- TREE if request-->
			<div class="col-2 box" v-if="cB.request.req">
				<InstanceRequest
					v-bind:request="cB.request.req"
					v-bind:buttons="cB.request.buttons"
					v-on:response="response({
						ClientBranch:cB,
						mode:cB.request.mode,
						button:$event,
						nod:$event.item
					})"
				/>
			</div>

			<!-- TREE if !request-->
			<div class="col-2 box" v-if="!cB.request.req"
				v-bind:style="{
					'padding-left': cB.tools.branch[0][2]==1 || cB.editBBuffer!==''?0:(cB.indent * 10)+'px',
					'min-width': displayVars.treeWidth +'px',
					'max-width': displayVars.treeWidth +'px',
				}"
				v-bind:class="{'box-top-border':cB.path=='001'}"
				tabindex="0"
				>
				<div class="row-toggle-button"
					v-if="cB.tools.branch[0][2]!==1 && cB.editBBuffer=='' && cB.Branch.path !== '001'"
					v-on:click="toggleChildVis(cB)"
					v-bind:class="{
						'hover': hasChildren(cB),
						'disabled':!hasChildren(cB)
					}"
					>
					<div v-text="cB.Branch.Child.isCollection ? cB.showChildren ? '-' : '+' : ' ' "/>
				</div>

				<!-- ******  BRANCH BUTTON GROUP  ****** -->
				<div class="popup-div" v-if="cB.tools.branch[0][2]==1 && !cB.editBBuffer">
					<BranchButtons
						inheritAttrs: false
						v-bind:btnConfig="cB.tools.branch"
						v-on:branchToolCode="handleBranch(cB,$event)"
					/>
				</div>

				<!-- ****** DISPLAY Branch.name ****** -->
				<div v-if="!cB.editBBuffer" class="test"
					v-bind:class="{
						'hover': !activeChild,
						root: cB.path == '001',
						open: cB.tools.branch[0][2]==1 && !cB.editBBuffer,
						disabled: cB.tools.branch[0][2]==1?false:cB.Branch.isHidden === true
					}"
					tabindex="0"
					v-on:keyup.esc="$emit('callTool', {ClientBranch:cB,tool:'branch',state:false})"
					v-on:click.stop="!activeChild || cB.tools.branch[0][2]==1?activateBranch(cB):null"
					v-text="cB.Branch.alias?cB.Branch.alias:cB.Branch.Child.name"
					contenteditable='false'
				></div>
					
				<!-- ******  EDIT Branch.name  ****** -->
				<div class="popup-div" v-if="cB.editBBuffer" >
					<!-- DROP EDITS -->
					<button class="button" v-on:click= "dropEdits(cB,index)"
						type="button"
						>X</button>
					<!-- EDIT Branch.name -->
					<Autocomplete
						v-on:selectedItem="handleAutoCompleteEvent({
							ClientBranch:cB,
							retVar:$event
						})"
						v-bind:defaultItem="cB.Branch.Child"
						v-bind:vars="{
							editOnly:!cB.draft,
							limitToList:!cB.draft
						}"
					/>
				</div>	
				<!-- Create/Edit BranchAlias -->
				<div class="popup-div" v-if="cB.display.substr(2,1) === '1'">
					<BranchAlias
						v-bind:alias="cB.Branch.alias"
						v-on:alias-updated="updateAlias({
							ClientBranch:cB,
							done:$event.done,
							alias:$event.alias
						})"
					/>
				</div>

			</div>

			<!-- FILTER -->
			<div class="col-3 box" v-if="editMode > 0"
				v-bind:style="{
					selectable:  !activeChild && !cB.Branch.Child.isCollection,
					'left': displayVars.editInstanceWidth + 'px',
					'min-width': displayVars.filterWidth +'px',
					'max-width': displayVars.filterWidth +'px'
				}"
				v-bind:class="{
					hover: editMode ==2 && !activeChild,
					'box-top-border':cB.path=='001'
				}"
				>
				<!-- ******  DISPLAY FILTER  ****** -->
				<!-- if request - display filter request -->
				<div v-if="cB.filter.request">
					<InstanceRequest
						v-bind:request="cB.filter.request"
						v-bind:buttons="['Y','N']"
						v-on:response="$emit('overwriteQueryResponse',$event)"
					/>
					</div>
				<!-- ******  filter tools X R  ****** -->
				<div v-if="cB.tools.filter">
					<button class="button hover" v-on:click.stop= "$emit('callTool', {ClientBranch:cB,tool:'filter',state:false})"
						type="button"
						v-bind:class="{hover: cB}"
					>X</button>							
					<button class="button"
						v-on:click.stop= "updateCBFilter(cB,0,$event)"
						type="button"
						:disabled="!cB.filter.Instance.value"
					>R</button>
					</div>
				<!-- SELECT/EDIT FILTER (instance) -->
				<!-- returnFilters=true only for root - this will present a list of existing saved filter names for this collection-->
				<InstanceAutocomplete v-on:selectedItem="updateCBFilter(cB,1,$event)"
					class="autoComplete"
					v-if="cB.tools.filter && cB.filterBuffer !==''"
					tabindex="0"
					v-bind:defaultItem="cB.filter.Instance"
					v-bind:authStatus="authStatus"
					v-bind:vars="{
						editOnly:cB.path === '001'?true:false,
						nodID:cB.Branch.Child.ID,
						limitToList:false,
						returnFilters:cB.path === '001'?true:false,
					}"
				/>
				<!-- if not request then display filter value -->
				<div v-if="!Tree.enableEdit && !cB.filter.request && !cB.tools.filter"
					v-on:click.stop="cB.Branch.Child.isCollection || activeChild?cB.path == '001'?callTool(cB):null:callTool(cB)"
					tabindex="0"
					v-bind:style="{
						'min-width': displayVars.filterWidth +'px',
						'max-width': displayVars.filterWidth +'px',
						'justify-content': cB.tools.filter?'flex-start':'center',
					}"
					v-bind:class="{
						root: cB.path == '001',quote: quote(cB),
						empty: cB.filter.Instance.value?false:true
					}"
					v-text="cB.filter.Instance.value" 
				/>
				</div>
			</div>
	</div>
</template>

<script>
	import _ from 'lodash'  // this is needed to use the sort function
	import {client} from '../main.js'
	import {v4 as uuidv4} from 'uuid'
	import Autocomplete from './AutoComplete.vue'
	import BranchAlias from './BranchAlias.vue'
	import BranchButtons from './BranchButtons.vue'
	import InstanceAutocomplete from './InstanceAutocomplete.vue'
	import InstanceRequest from './InstanceRequest.vue'
	import request from '../graphql/client/ClientBranch/requestFragment.gql'


	export default {
		name: 'TreeTable',
		components:{
			Autocomplete,
			BranchAlias,
			BranchButtons,
			InstanceAutocomplete,
			InstanceRequest
		},
		props:{
			authStatus:{
				type: Object,
				required: true
			},
			Tree: {
				type: Array,
				required: false,
			},
			displayVars:{
				type: Object,
				required:true
			},
			enableEdit:{
				type: Boolean,
				required: true,
			},
			activeChild: {
				type: Boolean,
				required: true
			},
			editMode:{
				type:Number,
				required: true
			},
			rootInstanceID:{
				type:String,
				required:true
			},
		},
		data() {
			return {
				mutationBuffer: {},
				activeBranch: '',
				showFilterTools:false,
			}
		},
		apollo:{},
		methods:{
			activateBranch(ClientBranch){
				// console.log('activateBranch -' , ClientBranch)
				if(this.editMode == 0){
					// two outcomes are possible here
					// 1. if branch tools are displayed then show the Autocomplete component (ClientBranch.editBBuffer !=='')
					// 2. show the branch tools
					if(ClientBranch.tools.branch[0][2]){
						// show Autocomplete component
						this.$emit('editBBuffer',{ClientBranch:ClientBranch,name:ClientBranch.Branch.Child.name})
					}else{
						// show Branch Tools
						this.$emit('callTool', {ClientBranch:ClientBranch,tool:'branch',state:true})	
					}
				}
			},
			callTool(ClientBranch){
				// console.log('callTool-TreeTable -', ClientBranch)
				// activate a tool for this ClientBranch
				// this will pass thorugh Collection to Cluster
				this.$emit('callTool', {ClientBranch:ClientBranch,tool:'filter',state:true})
			},
			dropEdits(ClientBranch){
				// console.log('dropEdits')
				// if the ClientBranch a draft, then delete it
				if(ClientBranch.draft){
					this.$emit('deleteClientBranch',{ClientBranch:ClientBranch})
				}else{
					this.$emit('callTool', {ClientBranch:ClientBranch,tool:'branch',state:false})
					this.$emit('editBBuffer',{ClientBranch:ClientBranch,name:''})
				}
			},
			handleAutoCompleteEvent(vars){
				const {ClientBranch,retVar} = vars
				// when adding a Branch the AutoComplete component returned somthing
				// remove the active tools for this ClientBranch
				this.$emit('callTool', {ClientBranch:ClientBranch,tool:'branch',state:false})
				const nod = retVar.item
				const code = retVar.code
				switch (code){
					// Cancel
					case 0: {
						this.dropEdits(ClientBranch)
					}
					break
					// update Nod.name
					case 1: {
						// compare editBBuffer to retVar.item.name
						// if not the same then request to update
						// console.log('update')
						if(ClientBranch.editBBuffer !== retVar.item.name){
							this.request({
								ClientBranch:ClientBranch,
								buttons: ['N','Y'],
								mode:'updateName',
								req:'Update "' + ClientBranch.editBBuffer + '" to "' + retVar.item.name + '"?',
								nod:retVar.item
							})
						}
					}
					break
					// add Branch with existing Nod
					case 2: {
						const vars = {
							ClientBranch:ClientBranch,
							nod:nod,
							// Collection: will be added in parent
						}
						this.$emit('addBranch',vars)
						this.$emit('deleteClientBranch', ({
							ClientBranch:ClientBranch
							// Collection: added when passing through Collection
						}))
					}
					break
					// create a new Nod add a Branch with it
					case 3: {
						this.request({
							ClientBranch:ClientBranch,
							buttons: ['C','V'],
							mode:'addBranch',
							req:"Collection or Value?",
							nod:nod
						})
					}
					break
				}
			},
			handleBranch(ClientBranch,vars){
				// console.log('handleBranch -' , vars)
				// console.log(ClientBranch)
				// Branch Mutations
				let {branchToolCode} = vars
				// console.log(var)
				switch(branchToolCode){
					case 'X': // Cancel
						this.dropEdits(ClientBranch)
					break
					// Add a new empty (no Branch.Child object) ClientBranch
					case 'A':
						// console.log('existing - handleBranch')
						this.$emit('addTempClientBranch', {
							ClientBranch:ClientBranch
						})
					break
					// Remove a Branch
					case 'R': {
						// confirm removeBranch
						this.request({
							buttons:['N','Y'],
							mode:'removeBranch',
							ClientBranch:ClientBranch,
							req:'Remove ' + ClientBranch.Branch.Child.name + '?',
							nod:ClientBranch.Branch.Child
						})
					}
					break
					case '+': // Move Down
						// console.log('move down')
							this.$emit('moveBranch',{ClientBranch:ClientBranch,direction:'+'})
					break
					case '-': // Move Up
						// console.log('move up')
						this.$emit('moveBranch',{ClientBranch:ClientBranch,direction:'-'})
					break
					case 'V': // Hide/Show Children
						this.$emit('hideBranch', {
							ClientBranch: ClientBranch,
							isHidden: ClientBranch.Branch.isHidden
						})
					break
					case 'N': { // NickName (Alias) Branch
						// Toggle the display of the alias input
						const newDisplayState = '0010';
						this.$emit('setClientBranchDisplay', {
							ClientBranch: ClientBranch,
							display: newDisplayState
						});
					}
					break
				}
				// hide <BranchButtons>
				this.$emit('callTool', {
					ClientBranch:ClientBranch,
					tool:'branch',
					state:false
				})
			},
			updateAlias(vars) {
				const{ ClientBranch, done, alias } = vars
				// console.log('updateAlias -', vars);
				// hide component
				this.$emit('setClientBranchDisplay', {
					ClientBranch: ClientBranch,
					display: '0000'
				});
				// update Alias
				if(done){
					this.$emit('updateBranchAlias', {
						ClientBranch: ClientBranch,
						alias: alias,
					});
				}
			},
			hasChildren(ClientBranch){
				const isRoot = ClientBranch.path =='001'?true:false
				const hasChildren = ClientBranch.Branch.Child.hasChildren
				return !hasChildren || isRoot
			},
			quote(ClientBranch){
				// the boolean result of this will determine if the quote class is applied to ClientBranch.filter.Instance.value
				// this will only be the case when a string is used as a filter and  ClientBranch.path  is not '001'
				const isRoot = ClientBranch.path == "001"
				const hasFilter = !_.isEmpty(ClientBranch.filter.Instance)
				const isFilter = hasFilter?ClientBranch.filter.Instance.isFilter:null
				return isRoot?false:isFilter
			},
			removeBranch(ClientBranch){
				// console.log('removeBranch-TreeTable')
				this.$emit('removeBranch',{ClientBranch:ClientBranch})
			},
			request(vars){
				// ask the user a question by 
				// overwriting ClientBranch.request
				// causes <trueFalse> component to display
				// console.log('request ', vars)
				const {ClientBranch,buttons,mode,req,nod} = vars
				const requestObj = {
					buttons:buttons,
					req:req,
					mode:mode,
					nod:nod,
					tree:{}
				}
				let ID = 'ClientBranch:{"ID":"' + ClientBranch.ID + '"}'
				client.writeFragment({
					id: ID,
					fragment: request,
					fragmentName: 'request',
					data: {request: requestObj},
				})
			
			},
			response(vars){
				const {ClientBranch,mode,button} = vars
				// clear the request
				this.request({
					ClientBranch:ClientBranch,
					buttons:[],
					mode:'',
					req:'',
					nod:{},
					tree:{}
				})
				// handle the users response to the request
				switch (mode){
					case 'addBranch': {
						const vars = {
							ClientBranch:ClientBranch,
							nod:{
								__typename:'Nod',
								name:ClientBranch.request.nod.name,
								isCollection:button=='C'?true:null
							}
						}
						this.$emit('addBranch',vars)
						this.$emit('deleteClientBranch', ({
							ClientBranch:ClientBranch
							// Collection: added when passing through Collection
						}))
					}
					break
					case 'removeBranch':{
						if(button == 'Y'){
							this.$emit('removeBranch',{ClientBranch:ClientBranch})
						}
					}
					break
					case 'deleteNod':{	
						if(button == 'Y'){
							this.$emit('deleteNod',{
								ClientBranch:ClientBranch,
								nod:ClientBranch.Branch.Child,
								tree:ClientBranch.request.tree
							})
						}
						if(button =='N'){
							this.$emit('deleteClientBranch',{ClientBranch:ClientBranch})
						}
					}
					break
					case 'updateName': {
						if(button == 'Y'){
							this.$emit('updateBranch',{
								ClientBranch:ClientBranch,
								nod:ClientBranch.request.nod
							})
						}
						if(button == 'N'){
							this.dropEdits(ClientBranch)
						}
					}
					break
				}
			},
			toggleChildVis(ClientBranch){// call toggle method in parent to hide/show children
				this.$emit('toggleChildVis', ClientBranch)
			},
			updateDigest(ClientBranch,digOp){
				// console.log(digOp)
				// hide the tools
				this.$emit('callTool', {ClientBranch:ClientBranch,tool:'digest',state:false})
				// perform the update or not
				const {branchToolCode} = digOp
				// console.log(branchToolCode)
				// skip this entire procedure if cancel
				if(branchToolCode !== 'X'){
					// get the Branches of sibling ClientBranches with digests
					const digestBranches = this.Tree.filter(t =>
							t.parentCB.path == ClientBranch.parentCB.path && t.Branch.digest
						).map(cB=>cB.Branch)
					// the branch that was clicked
					const selectedBranch = ({
						ID:ClientBranch.
						Branch.ID,
						digest:ClientBranch.Branch.digest
					})
					// vars for new digest values
					const fromBranch = {}
					const toBranch = {}
					// the output var
					const vars = []
					fromBranch.ID = ClientBranch.Branch.ID
					switch (branchToolCode){
						case 'A': // Add
							fromBranch.digest = (parseInt(digestBranches.length) + 1).toString()
						break
						case 'R': {// Remove
							fromBranch.digest = null
							const decrementDigests = digestBranches.filter(dB=> parseInt(dB.digest) > parseInt(ClientBranch.Branch.digest))
							// fill the hole created by removing the digest
							decrementDigests.map(b=> {
								const newDigest = (parseInt(b.digest)-1).toString()
								vars.push({ID:b.ID,digest:newDigest})
							})
						}
						break
						case '+':{ // Move Up (earlier in digest string)
							toBranch.ID = digestBranches.find(dB=> dB.digest == parseInt(ClientBranch.Branch.digest) +1).ID
							toBranch.digest = selectedBranch.digest
							fromBranch.digest = (parseInt(toBranch.digest) +1).toString()
							vars.push(toBranch)
						}
						break
						case '-':{ // Move down (later in digest string)
							toBranch.ID = digestBranches.find(dB=> dB.digest == parseInt(ClientBranch.Branch.digest) -1).ID
							toBranch.digest = selectedBranch.digest
							fromBranch.digest = (parseInt(toBranch.digest) -1).toString()
							vars.push(toBranch)
						}
						break
					}
					// call mutation in parent
					vars.push(fromBranch)
					this.$emit('updateDigest',vars)
				}
			},
			updateCBFilter(ClientBranch,filterMode,instanceObj){
				// console.log('Tree - updateCBFilter -', filterMode, instanceObj)
				// unload filter tools
				this.$emit('callTool', {ClientBranch:ClientBranch,tool:'filter',state:false})
				if(!instanceObj.Instance && instanceObj.iCode == 0){// cancel
					this.$emit('callTool', {ClientBranch:ClientBranch,tool:'filter',state:false})
				}else{
					const iCode = instanceObj ? instanceObj.code : 0  // null,0 returns 0 
					const Instance = filterMode == 0?{}:instanceObj.item ? instanceObj.item : {}

					if (iCode == 3){ // string did not match any Instances
						const now = new Date(); 
						Instance.ID = uuidv4()
						Instance.isFilter = true
						Instance.isPinned = false
						Instance.created = now.toISOString()
						Instance.__typename = "Instance"
					}
					if(!ClientBranch.Branch.Child.isCollection || ClientBranch.path == '001'){
						const vars = {
							ClientBranch: ClientBranch,
							Instance: Instance
						}
						this.$emit('updateCBFilter',vars)
					}
				}
			},
		},
		computed:{
			orderedTree: function () {
				// remove hidden rows
				return _.orderBy(this.Tree.filter(t=> t.isVisible) , 'path', 'asc')
			},
		},
	}	
</script>

<style scoped>

	.autoComplete{
		z-index: 1;
	}
	
	.tree-component {
		/* This overrides the global 'div' style to force the rows of the tree to stack vertically. */
		flex-direction: column;
		flex-shrink: 0;
		overflow: visible;
	}
	div{
		display: flex;
		position: relative;
	}

	.root{
		font-weight: bold;
	}

	.digest{
		display: flex;
		min-width: 14px;
		width: 100%;
		margin-right: 3px;
		justify-content: center;
	}

	.col-1{
		text-align: center;
		margin-right:3px;
		max-width: 15px;
		min-width: 15px;
	}
	
	.col-2{
		margin-right:5px;
	}

	.col-3{
		margin-right:10px;
		background-color: #d6edd3;
		width: 100%;
	}
	.empty:before {
		content:"\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0";
	}
	.quote:before {
	/*	add prefix '"' to Instance.value*/
		content:'"';
	}

	.quote:after {
	/*	add suffix '"' to Instance.value*/
		content:'"';
	}

	.button{
		background-color: #f0f0f0;
		border: 1px solid black;
		border-radius: 4px;
		justify-content: center;
		margin-left: .5px;
		margin-right: .5px;
		height: 24px;
		min-width: 17px;
	}
	
	.test{
		align-items: center;
		height: 100%;
		width: 100%;
		background-color: #f0f0f0;
	}

	.open{
		border: 1px solid black;
		border-radius: 4px;
		padding-left: 3px;
		padding-right: 3px;
	}

	.row-toggle-button{
		line-height: 100%;
		border-radius: 5px;
		display: flex;
		font-weight: bold;
		margin-top:2px;
		width: 14px;
		justify-content: center;
		font-weight: bold;
		font-size: 20px;
		height: 20px;
		padding-bottom: 2px;
	}

	.popup-div{
		display: inline-flex;
		overflow: visible;
		z-index: 1000;
	}

	.row{
		display: flex;
		flex-wrap: nowrap;
		height:24px;
		width:auto;
	}
	.row.root-row{
		position: sticky;
		top: 0;
		z-index: 100;
		background-color: #f0f0f0;
		/* box-shadow: 0 2px 4px rgba(0,0,0,0.1); */
	}

	.box{
		align-items: center;
		border-left: 1px solid black;
		border-right: 1px solid black;
		border-bottom: 1px solid black;
		box-sizing: border-box;
		display: flex;
		width: 100%;
	}
	.disabled{
		opacity:0.3;
	}

	.box-top-border{
		border-top: 1px solid black;
	}

	.hover:hover{
		background-color: #a6f4e5;
		cursor: pointer;
	}

</style>